/*@flow*/
export default Object.prototype.hasOwnProperty;
